/// localStorage-ключі цього робочого місця.
///
/// Свої, а не спільні з адмінкою (`fa_access_token`) і не з видаленої панелі
/// залу: спільний ключ колись тихо віддасть чужу сесію тому, хто відкриє два
/// продукти на одному хості.
export const ACCESS_TOKEN_KEY = 'eatlete_access'
export const REFRESH_TOKEN_KEY = 'eatlete_refresh'

/// Тема — властивість робочого місця (монітор у підвалі), не людини.
export const THEME_KEY = 'eatlete_theme'
